import {Space} from '@discordapp/tokens/web';

import {cssValueToNumber} from '../../utils/web/DomUtils';

export function useSpacingValue(token: Space) {
  const cssProp = getComputedStyle(document.documentElement).getPropertyValue(`--space-${token}`);
  return cssValueToNumber(cssProp);
}
